export const apiEndPoints = {
  // Home Routes //
  getHomePageSliderItems: '/home/getSliderItems',
  getHomePageScrollerItems: '/home/getScrollerItems',
  getHomePageSpotlightItems: '/home/getSpotlightItems',
  getHomePageTempleMissionItems: '/home/getTempleMissionItems',
  getHomePageTempleTiming: '/home/getTempleTiming',

  //to be further segrigates
  getHomePageDonationItems: '/home/getAllDonationItems',
  getAnnualCalender: '/home/getAnnualCalender',
  getHomePageServiceCatogryItems: '/home/getAllServiceCatogeryItems',
  getHomePagePanchang: '/home/getPanchang',
  getFullPagePanchang: '/home/get_full_panchang',
  getHomePageUpcomingEvents: '/home/getUpcomingEvents',
  getHomePageLatesNewsItems: '/home/getLatestNews',
  getHomePageLatesEventItems: '/home/getLatestEvents',
  getHomePagetodaysPujaSchedule: '/home/getTodaysPujaSchedule',
  getPujaSchedule: '/home/getPujaSchedule',
  getallNews: '/home/get_all_news',
  getliveStreamingUrl: '/home/get_live_streaming',
  getMonthlyNewsletter: '/home/get_monthly_newsletter',
  getAllNewsForTvGallery: '/home/getAllNewsForTvGallery',
  getIndividualNews: '/home/get_news_detail',

  // eventsAndActivities Routes //
  getEventDetailsBySlug: '/eventsAndActivies/getEventDetailsBySlug',
  getAllPaginatedEvents: '/eventsAndActivies/getAllPaginatedEvents',
  getActivities: '/eventsAndActivies/get_activities',
  balGokulBooking: '/eventsAndActivies/baalgokulorder/submit',
  getBalGokul: '/eventsAndActivies/baalgokul/list',
  allMeraApne: '/eventsAndActivies/mereapne/getAll',
  getUpcomingEvents: '/eventsAndActivies/getUpcomingEvents',
  allPbj: '/eventsAndActivies/pbj/getAll',
  allYouthTruth: '/eventsAndActivies/youthtruth/getAll',
  getFromByEventId: '/eventsAndActivies/eventticketform/getfrombyeventid',
  get_tvgallery_events: '/eventsAndActivies/get_tvgallery_events',
  getEnabledLotusAcademyClasses: '/eventsAndActivies/lotusacademy/getEnabledLotusAcademyClasses',

  // services Routes //
  getAllServiceCatogryItems: '/services/getAllServiceCatogeryItems',
  getAllServicesAtTempleByServicesSlug: '/services/getAllServicesAtTempleByServicesSlug',
  getServicesOutsideTemple: '/services/getServicesOutsideTemple',
  getAllServicesAtTemple: '/services/serviceAtTemple/listbycategory',
  serviceDetails: '/services/get_service_detail',
  getRental: '/services/get_rental',
  getRentalPurpose: '/services/rentals/purposes',
  allPujaSamagri: '/services/pujasamagri/getAll',
  getAllCateringItems: '/services/getAll_cateringItems',
  getAllCafeteriaItems: '/services/get_cafeteriaItems',
  getSpecificService: '/services/get_specific_service',
  getCategorizedCateringItems: '/services/getCategoriedCateringItems',
  getCategorizedCafeteriaItems: '/services/getCategoriedCafeteriaItems',
  getAllPersonalServices: '/services/getAllPersonalServices',

  // common Routes //
  nakshatram: '/common/get_nakshatram',
  nakshatrambyrashi: '/common/get_nakshatram_rashi',
  rashi: '/common/get_rashi',
  checkCorporateBody: '/common/check_corporate_body',
  rashibynakshatramid: '/common/get_rashi_nakshatram',
  languages: '/common/get_language',
  countries: '/common/get_country',
  state: '/common/get_state',
  getPriests: '/common/priest/getAll',
  getPriestLanguages: '/common/getPriestLanguage',
  getSearchData: '/common/searchbar/getall',
  getTempleConfigByCode: '/common/getTempleConfigByCode',
  getBookingConfigByTitle: '/common/getBookingConfigByTitle',
  getScrollerConfigs: '/common/getScrollerConfigs',
  getTempleConfig: '/common/getTempleConfig',
  getAllTags: '/common/getAllTags',
  getItemByCategory: '/common/getItemByCategory',
  getEventsCategories: '/common/event_categories_dropdown',
  getEmailHeader: '/common/getEmailHeader',
  getEmailFooter: '/common/getEmailFooter',
  getNoteConfig: '/common/getNoteConfig',

  // user route //
  getProfile: '/user/get_profile',
  getSankalp: '/user/get_sankalp',
  getDevoteeBySearch: '/user/searchDevotee',
  devoteeUpdate: '/user/update_profile',
  changePassword: '/user/change_password',
  contactUs: '/user/contact-us/store',
  getContactUsContent:'user/contact-us/get_content',
  volunteer: '/user/volunteer/add',
  registerOrderDetails: '/user/registerOrderDetails',
  addSankalp: '/user/add_sankalp',
  checkAvailability: '/user/check_availability',
  sendRejectionMail: '/user/send_rejection',
  getBookingData: '/user/get_booking',
  getOrderDetails: '/user/get_order_detail',
  getReportDetail: '/user/get_report_detail',
  sendReportMail: '/user/send_report_mail',

  //auth router
  devoteeRegister: '/auth/register',
  devoteeLogin: '/auth/login',
  verifyTwoFactor: '/auth/verifyTwoFactor',
  forgotPassword: '/auth/forgot_password',
  resetPassword: '/auth/reset_password',
  isValidResetToken: '/auth/is_valid_reset_token',
  subscribe: '/auth/subscribe',
  verifyNewsLetter: '/auth/verify_news_letter_otp',
  enableTwoFactor: '/auth/enableTwoFactor',
  verifyUserForTwoFactor: '/auth/verifyUserForTwoFactor',
  confirmTwoFactor: '/auth/confirmTwoFactor',
  requestDisableTwoFactor: '/auth/requestForDisableTwoFactor',
  disableTwoFactor: '/auth/disableTwoFactorAuthentication',
  // gallery routes //
  galleryCategories: '/gallery/get_gallery_categories',
  galleryFestivals: '/gallery/get_gallery_festivals',
  galleryTags: '/gallery/get_all_gallery_tags',
  allGallery: '/gallery/get_all_gallery',
  galleryPhotos: '/gallery/get_gallery_photos',
  galleryVideos: '/gallery/get_gallery_videos',
  getAllPlaylist: '/gallery/get_all_playlist',
  getAllPlaylist: '/gallery/get_all_playlist',
  allReligiousBooks: '/gallery/religiousbooks/getBooks',
  getAllbooksLanguages: '/gallery/booksLanguages/getAll',
  getAllbooksCategory: '/gallery/booksCategory/getAll',

  // payment routes //
  makeOnlinePayment: '/payment/makeOnlinePayment',
  makeOfflinePayment: '/payment/makeOfflinePayment',
  createPaymentIntent: '/payment/createPaymentIntent',
  createPaymentToken: '/payment/createPaymentToken',
  payPalCreateOrder: '/payment/paypal_create_order',
  payPalCaptureOrder: '/payment/paypal_orders/:id/capture',
  getPaymentDetails: '/payment/getPayment',
  //donation routes
  getAllDonations: '/donation/get_donation',
  getDonationByCategory: '/donation/get_donation_detail',

  //  VisitInfo Routes
  getLocation: '/visitInfo/get_location',
  getHotels: '/visitInfo/get_hotels',
  getFaq: '/visitInfo/get_faq',
  getGuidelines: '/visitInfo/get_devotee_guidlines',
  getPrasadamPolicy: '/visitInfo/get_prasadam_policy',

  // Request Routes
  getServiceOutsidePosRequest: '/request/getServiceOutsideRequest',
  makeOutsideRequest: '/request/makeOutsideRequest',
  getServiceOutsideRequestById: '/request/getServiceOutsideRequestById',
  getUserRequests: '/request/userrequests',
  cateringRequest: '/request/cateringRequest',
  getCateringRequest: '/request/getCateringRequests',
  updateCateringRequest: '/request/updateCateringRequest',
  getUserCateringRequests: '/request/getUserCateringRequests',
  getUserCateingRequestById: '/request/getUserCateringRequestById',
  createRequestOrder: '/request/createRequestOrder',
  createPersonalServiceRequest: '/request/createPersonalServiceRequest',
  getUserPersonalServicesRequest: '/request/getUserPersonalServiceRequest',
  getPersonalServiceRequestId: '/request/getPersonalServicesRequestById',

  // Pos Routes
  poslogin: '/pos/login',
  addPosOpeningAmount: '/pos/addOpeningAmount',
  addPosClosingAmount: '/pos/addClosingAmount',
  getCashierOpeningSummary: '/pos/cashierOpening',
  getCashierClosingSummary: '/pos/cashierClosing/summary',
  getAllActiveTerminals: '/pos/getAllActiveTerminals',
  updatePosLoggedinStatus: '/pos/updatePosLoggedinStatus',
  makeVolunteerOrder: 'pos/volunteerOrder',
  posKioskLogin: '/pos/kioskLogin',

  // Management Routes
  getCommitteeTypes: '/management/getCommitteeListWithTerms',

  getCommitteeMembers: '/management/committeeMember/list',
  templeBookingList: 'rentals/checkAvailability',
  getUserRentalRequests: '/rentals/userrentalrequests',
  getUserRentalRequestsById: '/rentals/getrentalrequestsbyid',
  sendRentalRequest: 'rentals/rentalRequest',
  updateRentalRequest: 'rentals/updateRentalRequest',
  getRentalBookings: 'rentals/getRentalBookings',
  getRentalInvoiceById: 'rentals/getRentalInvoiceById',
  getRentalTermandCondition: 'rentals/getTermsAndCondition',
  getRentalConditions: 'rentals/getRentalConditions',

  // createReoccurigDonationSubscription: "reoccuring_donation",
  recurringDonationPayment: '/payment/createStripSubscription',
  createReoccurigDonationSubscription: '/payment/reoccuring_donation_v2',
  // balGokulPayment: "make_stripe_payment_For_BalGokul",

  getContentArticalAndBylaws: '/aboutUs/getContentArticalAndBylaws',
  getContentTempleHistory: '/aboutUs/getTempleHistoryContent',
  getCareerData: '/aboutUs/getEnableCareer',
  getYearEndReport: '/aboutUs/getYearEndReport',
};

export const galleryType = {
  photo: 'photo',
  video: 'video'
};
